import React, { useEffect, useState } from "react";
// import { useGoogleLogout } from "react-google-login";
import AuthService from "../services/auth.service";
import { useNavigate } from "react-router-dom";

export default function RedirectPageToLogin() {
  const navigate = useNavigate();
  // const { signOut, loaded } = useGoogleLogout({
  //   clientId: `612031410089-8t2urlv7s9hv5c18hflligg56ctovbdh.apps.googleusercontent.com`,
  //   jsSrc: "https://apis.google.com/js/api.js",
  // });

  // useEffect(() => {
  //   if (loaded) {
  //     signOut();
  //     AuthService.logout();
  //     navigate("/login");
  //     window.location.reload();
  //   }
  // }, [loaded]);

  useEffect(() => {
    AuthService.logout();
    navigate("/login");
    window.location.reload();
  }, []);
  return <div>Redirecting ...</div>;
}
